var app = angular.module('leonardo');

var NavigationService = function($state, $timeout, AccountService, AccountUserRoleService, $filter, FilterService) {
  var service = {};

  service.redirectToState = function(state) {
    return $state.go(state.url, state.params);
  };

  service.goToUserAnonymousHome = function() {
    return $state.go('home');
  };

  service.goToMaintenance = function() {
    return $state.go('maintenance');
  };

  service.goToUserLoggedHome = function() {
    return $state.go('dashboard');
  };

  service.goToOnBoarding = function() {
    return $state.go('onboarding');
  };

  service.goToStaffLoggedHome = function() {
    return $state.go('users');
  };

  service.goToLoginRedirection = function() {
    return $state.go('login-redirection');
  };

  service.goToLoginRedirectionWorkAs = function() {
    return $state.go('login-redirection-work-as');
  };

  service.goToRegionalLogin = function() {
    return $state.go('portfolios.overview', {fromOnboarding: true });
  };

  service.goToTaskOverview = function() {
    return $state.go('property.tasks');
  };

  service.goToApprovals = function() {
    return $state.go('approvals');
  };

  service.isExternal = function (authData) {
    var is_external = false;
    angular.forEach(authData.accountUsers, function (accountUser){
      if (accountUser.role && !isNull(accountUser.role.base_type) &&
        (accountUser.role.base_type.toString() === AccountUserRoleService.BASE_TYPE_EXTERNAL_APPROVER)) {
        is_external = true;
      }
    });
    return is_external;
  };

  service.goToHome = function (authData) {
    if (isEmpty(authData)) {
      service.goToUserAnonymousHome();
      return;
    }
    if (service.isExternal(authData)) {
      service.goToApprovals();
      return;
    }
    if (authData.user && (authData.user.is_staff || authData.user.is_white_label_admin)) {
      service.goToStaffLoggedHome();
      return;
    }
    // Owner login
    if (authData.accountUser && authData.accountUser.is_owner) {
      if (authData.account && (authData.account.status.toString() === AccountService.STATUS_ON_BOARDING)) {
        service.goToOnBoarding();
        return;
      }
      service.goToUserLoggedHome();
      return;
    }
    // Has portfolios
    let currentAccountPortfolios = $filter('filter')(FilterService.portfolios, {
      account: authData.accountUser.account,
    });
    if (authData.accountUser && (currentAccountPortfolios.length > 0)) {
      service.goToUserLoggedHome();
      return;
    }

    service.goToTaskOverview();
  }

  return service;
};

app.factory('NavigationService', ['$state', '$timeout', 'AccountService', 'AccountUserRoleService','$filter', 'FilterService', NavigationService]);
